import React from 'react'
import ReactDOM from 'react-dom'
import './index.css'
import App from './app'
import { Provider } from 'react-redux'
import store from './app/utils/store'
import ThemeProvider from './app/ThemeProvider'

ReactDOM.render(
  <Provider store={store}>
    <ThemeProvider>
      <App />
    </ThemeProvider>
  </Provider>,
  document.getElementById('root')
)
